import React from 'react';

interface TabProps {
  label: string;
  isActive: boolean;
  onClick: () => void;
  className?: string;
}

/**
 * Tab component for tab navigation
 */
const Tab: React.FC<TabProps> = ({
  label,
  isActive,
  onClick,
  className = '',
}) => {
  return (
    <button
      className={`
        py-3 px-4 border-b-2 text-sm font-medium min-h-[44px]
        ${isActive 
          ? 'border-primary-500 text-primary-600 dark:border-primary-400 dark:text-primary-300' 
          : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-200 dark:hover:border-gray-600'}
        ${className}
      `}
      onClick={onClick}
    >
      {label}
    </button>
  );
};

export default Tab;